module.exports = __webpack_public_path__ + "img/BG-Orang-Kerry-Club.76029ddf.jpg";